"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is the Yoga Dinners experience?",
  answer: "It is a high-vibration sanctuary where movement meets ritual. Each evening begins with a deep-bass yoga flow, followed by a communal multi-course dinner designed to nourish the body and awaken the senses in a cinematic, candlelit setting."
}, {
  question: "Do I need prior yoga experience to attend?",
  answer: "Our gatherings are inclusive of all levels. The movement is designed to be a sensory journey—less about technical perfection and more about rhythmic connection, presence, and the collective energy of the room."
}, {
  question: "What should I wear to a gathering?",
  answer: "We encourage attire that feels both functional for movement and expressive of your personal style. Think premium, minimal, and comfortable—pieces that transition seamlessly from the mat to the dinner table."
}, {
  question: "How are the menus curated for each event?",
  answer: "Our culinary team crafts seasonal, plant-forward menus that mirror the energy of the music and movement. Every dish is a ritual in itself, designed to foster connection and celebrate the art of shared dining."
}, {
  question: "Can I book a private Yoga Dinners ritual?",
  answer: "Yes, we curate bespoke immersive experiences for private groups and brands looking to create a powerful, mystical connection through movement, music, and elevated hospitality."
}];
export default function Faq() {
  return <section data-section-id="257473" id="termsofservice" className="py-20 bg-background text-foreground">
      <div className="container mx-auto px-6 md:px-8 max-w-3xl">
        <div className="text-center mb-12 mx-auto">
          <span className="text-primary font-semibold tracking-widest uppercase text-sm mb-3 block font-sans">
            The Ritual Protocol
          </span>
          <h2 className="text-[36px] leading-tight font-bold text-foreground font-default">
            Terms of Service & Connection
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-none bg-card/40 backdrop-blur-sm rounded-md px-6 md:px-8 shadow-lg">
              <AccordionTrigger className="hover:no-underline py-6 text-[18px] font-bold text-foreground font-default text-left [&>svg]:text-primary [&>svg]:bg-primary/10 [&>svg]:rounded-md [&>svg]:p-1.5 [&>svg]:w-5 [&>svg]:h-5 [&>svg]:box-content">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[18px] text-muted-foreground font-sans pb-8 leading-relaxed pr-12">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}